import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { GeneralService } from 'src/app/providers/general/general.service';
import { LeaveService } from 'src/app/providers/leave/leave.service';
import { QueryService } from 'src/app/providers/query/query.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import { QuickLinks } from 'src/app/shared/models/header/quicklinks.interface';
import { PoliciesService } from 'src/app/providers/policy/policies.service';
import { isQuickLinks } from 'src/app/state/userMap.action';
import { GetQuickLinks } from 'src/app/state/userMap.reducer';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { TalentService } from 'src/app/providers/talent/talent.service';
import { EmployeeService } from 'src/app/providers/employee/employee.service';
import { environment } from 'src/environments/environment';

import { CommunicationService } from 'src/app/providers/communication/communication.service';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { ComponentPortal, Portal } from '@angular/cdk/portal';
import { LeaveApprovalComponent } from 'src/app/shared/components/approvals/leave-approval/leave-approval.component';
import { AllApprovalComponent } from 'src/app/shared/components/approvals/all-approval/all-approval.component';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import { SidebarService } from 'src/app/providers/sidebar/sidebar.service';
import { forEach } from 'jszip';
import { AuthService } from 'src/app/providers/auth/auth.service';
declare let $: any;
declare var google;
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  animations: [
    trigger('slideInOut', [
      state(
        'in',
        style({
          width: '0%',
        })
      ),
      state(
        'out',
        style({
          width: '100%',
        })
      ),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out')),
    ]),
  ],
})
export class AdminComponent implements OnInit, AfterViewInit {
  selected: Date | null;
  disabled: boolean = true;
  minCalDate: Date;
  maxCalDate: Date;
  canvasState: string = 'in';
  selectedPortal: Portal<any>;
  componentPortal: ComponentPortal<any>;
  public marqueeText = '';
  public mrfApprovalsCount = 0;
  public idCardApprovalsCount = 0;
  public mrfApprovals: any = [];
  public idCardApprovals: any = [];
  public approvals: any = [];
  public mrfApproval: any = [];
  public attRegulariseData: any = [];
  public attRegulariseDataCount: any = 0;
  public mrfApproveForm: FormGroup;
  public resolveFormIDCard: FormGroup;
  public resolveFormExpense: FormGroup;
  public mrfBulkApproveForm: FormGroup;
  public mrfApproveFormHeader: any;
  public submitted = false;
  public response: any = [];

  public exitApprovalsCount = 0;
  public exitApprovals: any = [];
  public exitApproveForm: FormGroup;
  public exitHeader: any;
  public submitt = false;

  public expenseApprovalsCount = 0;
  public expenseApprovals: any = [];

  public awardApprovalsCount = 0;
  public awardApprovals: any = [];
  public epaApprovalsCount = 0;
  public epaApprovals: any = [];
  public workPlaceApprovalsCount = 0;
  public workPlaceApprovals: any = [];
  public resolveForm: FormGroup;
  public regulariseFrom: FormGroup;
  resolveAction: any = [
    { label: 'Approve', value: 1 },
    { label: 'Reject', value: 0 },
  ];
  loading = false;
  submit = false;
  awardData: any = [];
  awardTxn: any;
  btnName = 'Approve';
  awardLimit = 5;
  public exitBulkApproveForm: FormGroup;
  exitBulkHeader: any;
  public result: any = [];
  empData: any;
  public page = 1;
  public count = 0;
  public pageSize = 10;
  public from;
  public to;

  bDayData: any = [];
  bDayCount = 0;
  annivrsryData: any = [];
  annvrsryCount = 0;
  idCardData: any;
  assignQueryData: any = [];
  quickLinksIcons: any = [];
  quickLinksIconsCopy: any = [];
  quickLinksTemp: any = [];
  hasIcons = false;
  srchText: any;
  quickLinksMenu$: Observable<QuickLinks[]>;
  @ViewChild('itemSearchInput', { static: true }) itemSearchInput: ElementRef;
  submitExp: boolean;
  expenseData: any;
  smarttripApprovals: any;
  activeApps: any = [];
  complntImg: any = [];
  complaintForm: FormGroup;
  ftcRistrict: any = false;
  submitCmplnt = false;
  expensesCount: any = 0;
  smarttripCount: any = 0;
  policies: any = [];
  // exit update
  exitUpdateForm: FormGroup;
  updateExit = false;
  voltryList: any = [];
  reasonList: any = [];

  extendExit: FormGroup;
  minDate: any;
  updateExitDate = false;

  exitRejectForm: FormGroup;
  exitReject = false;
  transferApprovalsCount = 0;
  ftcRenewalCount = 0;
  transferApprovals: any;
  loadingBulkApprove = false;
  // idcard
  empIDInfo: any = [];
  emplID = '';
  hasData = false;
  ftcRenewalApprovals: any;
  renewLetter: any;
  userId: any;
  approvalData: any;
  approvalDataCount = 0;
  mrfApprovalsCountEmp = 0;
  transferApprovalsCountEmp = 0;
  ftcRenewalCountEmp = 0;
  exitApprovalsCountEmp = 0;
  awardApprovalsCountEmp = 0;
  idCardApprovalsCountEmp = 0;
  workPlaceApprovalsCountEmp = 0;
  expensesCountEmp = 0;
  smarttripCountEmp = 0;
  expenseApprovalsEmp: any;
  smarttripApprovalsEmp: any;
  pettyCashApprovalCount = 0;
  pettyCashExpenseApprovalCount = 0;
  pettyCashApprovals: any = [];
  pettyCashExpenseApprovals: any = [];
  rejectForm: FormGroup;
  remSubmit = false;
  pettyReqRejRemark;
  pettyExpnsRejRemark;
  pettyApprObj: any;
  pettyExpnsApprObj: any;
  encMrfId: any;
  renewalForm: FormGroup;
  renewalData: any;
  renewalDataCount = 0;
  costCenters: any;
  showBulkApproval = false;
  visitingCardApprovalsCount = 0;
  public visitingCardApprovals: any = [];
  napsMrfApprovalsCount = 0;
  napsMrfApprovals: any = [];
  ongcpassCount = 0;
  ongcApprovals: any = [];
  language;
  refyneList;
  hseDocuments;
  refyneLang: any = [];
  docUrl: any;
  appURL: any;
  refyneLabel: any;
  cat_1: any;
  cat_2: any;
  cat_3: any;
  cat_4: any;
  bottomText: any;
  newJoiningList: any = [];
  mainLeaves: any = [];
  public username: string = '';
  isSelf: boolean;
  reportiesLeaveMsg: string = '';
  reportLeavesCount: any = [];
  isLastAvrsry = false;
  showPopup = false;
  qrycount: any;
  myQueryData: any = [];
  assignQueryLength: number = 0;
  wishAnimation: boolean = false;
  isLastAwardPage = false;
  isLastNewsPage = false;
  public countR = 0;
  public countF = 0;
  newsData: any = [];
  countNewJoining: any;
  public pageSizeF = 50;
  public pageF = 1;
  ijpListReular: any = [];
  ijpListReularCount: any;
  ijpListCount: any;
  ijpListFTC: any;
  public fromF;
  public toF;
  newsLimit = 5;
  clickEvModal: Subject<any> = new Subject();
  isViewMore: boolean = true;
  totalApprovals: number = 0;
  leaveApprovalsCount: number = 0;
  calenderData: any = [];
  pendingEmpBuddyCount = 0;
  buddyPendingEmployeeList: any = [];
  bdayWish = '';
  crntBday: any = {};
  wishType;
  todayDate: any;
  modifyQuickLink: any = [];
  modifyQckKey: any;
  modifyQckKeyName: any;
  modifyQuickLinkCopy: any = [];
  calShortMonthName: string = '';
  calYear: number = 0;
  totalCountFR = 0;
  customOptions: OwlOptions = {
    // loop: true,
    margin: 0,
    autoplay: true,
    // responsiveClass: true,
    // navText: ['<', '>'],
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
    // nav: true,
  };
  vdoOptions: OwlOptions = {
    // loop: true,
    // autoplay: true,
    // responsiveClass: true,
    // navText: ['<', '>'],
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
    // nav: true,
  };
  constructor(
    private translate: TranslateService,
    private dashboardService: DashboardService,
    private notifyService: NotificationService,
    private empService: EmployeeService,
    public router: Router,
    private store: Store,
    private leaveServe: LeaveService,
    private https: HttpClient,
    private formBuilder: FormBuilder,
    private queryServ: QueryService,
    private generalServ: GeneralService,
    private talentService: TalentService,
    private policy: PoliciesService,
    private httpComs: CommunicationService,
    private sideServ: SidebarService,
    private authSer: AuthService
  ) {
    this.minDate = moment().startOf('month').format('YYYY-MM-DD');
    this.todayDate = moment().format('YYYY-MM-DD');

    console.log(this.todayDate);
  }

  ngAfterViewInit() {
    this.atCal();
    this.sideServ.getApprovalDialog().subscribe((res) => {
      console.log(res);
      this.toggleMenu();
      this.componentPortal = new ComponentPortal(AllApprovalComponent);
      this.selectedPortal = this.componentPortal;
    });
  }

  atCal(): void {
    this.leaveServe.attendanceCalendar({}).subscribe((res) => {
      const data = res.data;
      this.calenderData = res.data;
      this.calShortMonthName = res.month_name;
      this.calYear = res.year;
      console.log(data);
    });
  }

  submitToken(): void {
    this.router.navigateByUrl('/dashboard/news-landing-page');
  }

  leaveApprovals() {
    this.toggleMenu();
    this.componentPortal = new ComponentPortal(LeaveApprovalComponent);
    this.selectedPortal = this.componentPortal;
    console.log(this.componentPortal);
  }
  ngOnInit(): void {
    // this.initMap()
    this.rejectForm = new FormGroup({
      rej_remark: new FormControl('', Validators.required),
      renew_id: new FormControl(''),
      user_id: new FormControl(''),
    });
    // this.renewalForm = new FormGroup({
    //   start_date: new FormControl(''),
    //   end_date: new FormControl(''),
    //   type: new FormControl(''),
    //   user_id: new FormControl(''),
    //   cc_id: new FormControl(''),
    // });
    this.getEmployeeType();
    this.getEmpCostCenters();
    // this.onSubmitRenewal('0');
    // this.employeeApprovals();
    this.getMyApprovals();
    this.getAttendanceReguarisationRequest();
    this.createMrfApproveForm();
    this.createMrfBulkApproveForm();
    this.exitApproveFormField();
    this.createExitBulkApproveForm();
    this.resolveFormFields();
    this.resolveFormFieldsIDCard();
    this.resolveFormFieldExpense();
    this.getLoggedInEmpDetails(true);

    this.getBdays();
    this.getWrkAnnvrsry();
    this.assignQueryMaster();
    this.myQueryMaster();
    this.iconInit();
    this.regulariseFormFields();
    this.cmplntFieldInit();
    this.exitUpdateFormInit();
    this.exitDateFormInit();
    this.exitRejectRemarkForm();
    this.idCardDetails(this.emplID);
    this.getRefineLang(this.refyneList);
    this.refyneAppLabel();
    this.getNewJoinings();
    this.getPolicy();
    this.leaveCard();
    this.searchJobsFTC('');
    // this.searchJobsRegular('');
    // this.store.dispatch(isQuickLinks({ status: true }));
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.body.appendChild(tag);
  }
  employeeApprovals(): void {
    this.dashboardService.employeeApprovals().subscribe((res) => {
      this.response = res;
      if (this.response.status) {
        this.approvalDataCount = this.response.count;
        if (this.approvalDataCount != 0) {
          $('#employee_approver_modal').modal('show');
        }
      } else {
        this.approvalData = [];
      }
    });
  }

  getEmployeeType(): void {
    this.generalServ.isBaseRegular().subscribe(
      (res) => {
        this.ftcRistrict = res.is_ftc;
      },
      (err) => {
        this.ftcRistrict = false;
      }
    );
  }
  showAllApproval() {
    this.toggleMenu();
    this.componentPortal = new ComponentPortal(AllApprovalComponent);
    this.selectedPortal = this.componentPortal;
  }
  myQueryMaster(): void {
    const commonData = {
      date_range: ['logged_by'],
      is_excel: [0],
      limit: 5,
      page: this.page,
    };
    this.queryServ.getMyQueryMaster(commonData).subscribe((res: any) => {
      //console.log(res.data);
      if (res.status) {
        this.myQueryData = res.data.data;
        this.qrycount = res.data.total;
      } else {
        this.myQueryData = [];
      }
    });
  }

  getAwards(limt): void {
    this.dashboardService
      .awardsForDashbord({ limit: limt })
      .subscribe((res) => {
        console.log(res);
        if (res.status) {
          this.awardData = res.data.data;
          if (this.awardData.length == res.data.total) {
            this.isLastAwardPage = true;
          } else {
            this.isLastAwardPage = false;
          }
          this.awardData.forEach((ele) => {
            ele.commentIndex = 2;
          });
        } else {
          this.awardData = [];
        }
      });
  }

  likeUnlikeAward(data): void {
    this.dashboardService.likeUnlike(data).subscribe((res) => {
      this.getAwards(this.awardLimit);
    });
  }

  doComment(data): void {
    if (!data.comment) {
      this.notifyService.showError('Please enter comment', 'Info!');
      return;
    }
    this.dashboardService.commentAction(data).subscribe((res) => {
      this.getAwards(this.awardLimit);
    });
  }

  moreAward(): void {
    this.awardLimit += 5;
    this.getAwards(this.awardLimit);
  }

  moreNews(): void {
    this.newsLimit += 5;
    this.getGeneralNews(this.newsLimit);
  }

  viewAllComment(data): void {
    data.commentIndex += 2;
  }

  hideComments(data): void {
    data.commentIndex = 2;
  }

  getGeneralNews(limits): void {
    const param = {
      limit: limits,
      is_home_page: 1,
      source: 'Web',
      is_for_alumini: '1',
    };
    this.httpComs.getGeneralNews(param).subscribe((res) => {
      if (res.status) {
        this.newsData = res.data.data;
        if (this.newsData.length == res.data.total) {
          this.isLastNewsPage = true;
        } else {
          this.isLastNewsPage = false;
        }
        this.newsData.forEach((ele) => {
          // ele.commentIndex = 2;
          ele.img_arr = [];
          ele.vdo_arr = [];
          ele.files = [];
          ele.youtube_files = [];
          ele.docs.forEach((element) => {
            if (element.doc_type == 'img') {
              ele.img_arr.push(element.attach_info);
            } else if (element.doc_type == 'video') {
              ele.vdo_arr.push(element.attach_info);
            } else {
              if (this.validateYouTubeUrl(element.attach_info) != false) {
                ele.youtube_files.push(
                  this.validateYouTubeUrl(element.attach_info)
                );
              } else {
                ele.files.push(element.attach_info);
              }
            }
          });
        });
        console.log(this.newsData);
        if (this.newsData.length == res.data.total) {
          this.isLastNewsPage = true;
        } else {
          this.isLastNewsPage = false;
        }
      } else {
        this.newsData = [];
      }
    });
  }

  validateYouTubeUrl(url): any {
    console.log(url);
    let regExp =
      /(?:\?v=|\/embed\/|\.be\/|\/v\/|\/\d{1,2}\/|\/vevo\/|youtu\.be\/|\/embed\/|\/v\/|e\/|youtu\.be\/|embed\/|watch\?v=|&v=|&vi=|vi=|https:\/\/www\.youtube\.com\/watch\?v=)([^#\&\?]{11})/;
    let matches = url.match(regExp);
    console.log(matches);
    if (matches) {
      console.log(matches);
      return matches[1];
    } else {
      return false;
    }
  }

  greetingModal(): void {
    setTimeout(() => {
      $('#myModal_s').modal('show');
      localStorage.setItem('showBallon', 'true');
      localStorage.setItem('eventDate', this.todayDate);
      setTimeout(() => {
        $('#myModal_s').modal('hide');
        this.soNewsModal();
      }, 5000);
    }, 5000);
  }

  soNewsModal(): void {
    const tmp = localStorage.getItem('popUp');
    const date = localStorage.getItem('date');
    const usrId = localStorage.getItem('usrId');
    if (tmp && date == this.todayDate && this.empData) {
      if (usrId == this.empData.id) {
      } else {
        localStorage.setItem('popUp', 'true');
        localStorage.setItem('date', this.todayDate);
        if (this.empData.id) {
          localStorage.setItem('usrId', this.empData.id);
        }
        $('#myModal_so_news').modal('show');
      }
    } else {
      localStorage.setItem('popUp', 'true');
      localStorage.setItem('date', this.todayDate);
      if (this.empData.id) {
        localStorage.setItem('usrId', this.empData.id);
      }
      $('#myModal_so_news').modal('show');
    }
  }

  likeUnlikeNews(data, typeId): void {
    const param = {
      txn_id: data.txn_id,
      type: typeId,
    };
    this.dashboardService.likeUnlikeNews(param).subscribe((res) => {
      // this.getGeneralNews(this.newsLimit, false);
      if (data.can_like) {
        data.can_like = false;
        data.like_count = data.like_count + 1;
      } else {
        data.can_like = true;
        if (data.like_count > 0) {
          data.like_count = data.like_count - 1;
        }
      }
    });
  }

  doCommentNews(data, txnId, type): void {
    if (!data.usr_comment) {
      this.notifyService.showError('Please enter comment', 'Info!');
      return;
    }
    const param = {
      txn_id: txnId,
      comment: data.usr_comment,
      type: type,
    };
    this.dashboardService.commentActionNews(param).subscribe((res) => {
      if (type == 1) {
        data.comment_arr.push({
          can_like: true,
          txn_id: res.last_insert_id,
          comment: data.usr_comment,
          commentIndex: 2,
          date: moment().format('DD-MM-YYYY'),
          emp_img: '',
          name: localStorage.getItem('user_name'),
        });
        data.comment_count = data.comment_count + 1;
      } else {
        if (!data.reply_arr) {
          data.reply_arr = [];
        }
        data.reply_arr.push({
          can_like: true,
          txn_id: res.last_insert_id,
          comment: data.usr_comment,
          commentIndex: 2,
          date: moment().format('DD-MM-YYYY'),
          emp_img: '',
          name: localStorage.getItem('user_name'),
        });
      }

      data.usr_comment = '';
      data.comment_count = data.comment_count + 1;
    });
  }

  viewAllCommentNews(data): void {
    data.commentIndex += 2;
  }

  hideCommentsNews(data): void {
    data.commentIndex = 2;
  }

  pinNews(data): void {
    const param = {
      nws_txn_id: data.txn_id,
    };
    this.httpComs.pinNews(param).subscribe((res) => {
      this.notifyService.showSuccess(res.msg, 'Success!');
      // this.getGeneralNews(this.newsLimit, false);
      data.can_pin = false;
    });
  }

  parentFunction(event): void {
    console.log(event);
  }
  get resolveErrorMsg(): any {
    return this.resolveForm.controls;
  }
  get expErrorMsg(): any {
    return this.resolveFormExpense.controls;
  }
  get resolveIDCardErrorMsg(): any {
    return this.resolveFormIDCard.controls;
  }

  // get exitUpdateErrorMsg(): any {
  //   return this.exitUpdateForm.controls;
  // }
  get exitDateErrorMsg(): any {
    return this.extendExit.controls;
  }
  get exitRemarkErrorMsg(): any {
    return this.exitRejectForm.controls;
  }
  // tslint:disable-next-line: typedef
  get mrfApproveFormControls() {
    return this.mrfApproveForm.controls;
  }
  // tslint:disable-next-line: typedef
  get mrfBulkApproveFormControls() {
    return this.mrfBulkApproveForm.controls;
  }

  get cmplntErrMsg(): any {
    return this.complaintForm.controls;
  }

  cmplntFieldInit(): void {
    this.complaintForm = this.formBuilder.group({
      plant_name: [''],
      logged_by: [''],
      reqcontact: [''],
      reqemail: [''],
      subject: ['', Validators.required],
      remark: ['', Validators.required],
      module: ['', Validators.required],
      ticket_screenshot: ['', Validators.required],
    });
  }

  idCardDetails(empID): void {
    this.hasData = false;
    this.dashboardService.empIDCardDetails(empID).subscribe((res) => {
      this.hasData = true;
      this.empIDInfo = res.data;
    });
  }

  childOutput(event): void {
    if (event.isAdd) {
      this.idCardDetails('');
    } else if (event.emp_id != '') {
      this.idCardDetails(event.emp_id);
    }
  }

  // exit Reason updation

  // openExitupdateModal(modalID, data, id): void {
  //   $(modalID).modal({ backdrop: 'static', keyboard: false });
  //   if (id == 1) {
  //     this.getVouluntaryGrp(data.vltry_id, data.rsn_id);
  //     this.exitUpdateForm.patchValue({
  //       exit_id: data.exit_id,
  //       rpls_rm_username: data.nrm_emp_name,
  //     });
  //   } else if (id == 2) {
  //     this.extendExit.patchValue({
  //       exit_id: data.exit_id,
  //     });
  //   }
  // }

  // closeExitUpdateModal(): void {
  //   this.updateExit = false;
  //   this.exitUpdateForm.reset();
  //   $('#exit_update_modal').modal('hide');
  // }

  getVouluntaryGrp(vltryId, rsn_id): void {
    this.dashboardService.getModOptions(18).subscribe((res) => {
      this.response = res;
      this.voltryList = this.response.data;
      this.getReasonsOption(vltryId, rsn_id);

      setTimeout(() => {
        this.exitUpdateForm.patchValue({
          vltry_id: vltryId,
        });
      }, 100);
    });
  }

  // changeExitType(event): void {
  //   this.getReasonsOption(event.target.value);
  // }

  getReasonsOption(vlId, rsnID = ''): void {
    this.dashboardService.getReasonsOption(vlId).subscribe((res) => {
      this.response = res;
      this.reasonList = this.response.data;
      setTimeout(() => {
        this.exitUpdateForm.patchValue({
          rsn_id: rsnID,
        });
      }, 100);
    });
  }

  exitUpdateFormInit(): void {
    this.exitUpdateForm = this.formBuilder.group({
      exit_id: [''],
      vltry_id: ['', Validators.required],
      rsn_id: ['', Validators.required],
      rpls_rm_username: [''],
      rpls_rm_id: [''],
    });
  }
  // onInput(event): void {
  //   if (event.target.value.length === 0) {
  //     this.exitUpdateForm.patchValue({
  //       rpls_rm_id: '',
  //     });
  //   }
  // }
  // searchEmp(): void {
  //   if (this.exitUpdateForm.get('rpls_rm_username').value) {
  //     this.generalServ
  //       .searchEmployee(this.exitUpdateForm.get('rpls_rm_username').value)
  //       .subscribe(
  //         (res) => {
  //           this.result = res;
  //           if (this.result.status) {
  //             this.exitUpdateForm.patchValue({
  //               rpls_rm_username:
  //                 this.result.data[0].username +
  //                 ' - ' +
  //                 this.result.data[0].name,
  //               rpls_rm_id: this.result.data[0].id,
  //             });
  //             // this.empID = this.result.data[0].id;
  //             // this.isSearch = true;
  //           } else {
  //             this.exitUpdateForm.patchValue({
  //               rpls_rm_username: '',
  //               rpls_rm_id: '',
  //             });
  //             this.notifyService.showError(this.result.msg, 'Info!');
  //           }
  //         },
  //         (err) => {}
  //       );
  //   } else {
  //     this.exitUpdateForm.patchValue({
  //       rpls_rm_username: '',
  //       rpls_rm_id: '',
  //     });
  //     this.notifyService.showInfo('Please Enter User Id', 'Info!');
  //   }
  // }
  // onUpdateExit(): void {
  //   this.updateExit = true;
  //   if (this.exitUpdateForm.invalid) {
  //     return;
  //   } else {
  //     this.dashboardService
  //       .exitUpdate(this.exitUpdateForm.value)
  //       .subscribe((res) => {
  //         if (res.status) {
  //           this.closeExitUpdateModal();
  //           this.getMyApprovals();
  //           this.notifyService.showSuccess(res.msg, 'Success!');
  //         } else {
  //           this.notifyService.showError(res.info, 'Error!');
  //         }
  //       });
  //   }
  // }

  // exit date update

  exitDateFormInit(): void {
    this.extendExit = this.formBuilder.group({
      exit_id: [''],
      ext_date: ['', Validators.required],
    });
  }

  // closeExitDateModal(): void {
  //   this.updateExitDate = false;
  //   this.extendExit.reset();
  //   $('#exit_date_modal').modal('hide');
  // }

  // onSubmitExitDate(): void {
  //   this.updateExitDate = true;
  //   if (this.extendExit.invalid) {
  //     return;
  //   } else {
  //     this.talentService
  //       .updateExtendDate(this.extendExit.value)
  //       .subscribe((res) => {
  //         if (res.status) {
  //           this.notifyService.showSuccess(res.msg, 'Success!');
  //           this.closeExitDateModal();
  //           this.getMyApprovals();
  //         } else {
  //           this.notifyService.showError(res.msg, 'Error!');
  //         }
  //       });
  //   }
  // }

  // exit reject remark modal

  // ecai(modalID): void {
  //   $(modalID).modal({ backdrop: 'static', keyboard: false });
  // }

  closeExitReson(): void {
    this.exitReject = false;
    this.exitRejectForm.reset();
    $('#exit_reject_remark').modal('hide');
  }

  exitRejectRemarkForm(): void {
    this.exitRejectForm = this.formBuilder.group({
      exit_id: [''],
      status: [''],
      rel_id: [''],
      emp_user_id: [''],
      approver_remark: ['', Validators.required],
    });
  }

  showPolicy(): void {
    this.router.navigate(['/quick-links/policies']);
  }

  // onSubmitExitRejection(): void {
  //   this.exitReject = true;
  //   if (this.exitRejectForm.invalid) {
  //     return;
  //   } else {
  //     this.exitApprovalRequest(this.exitRejectForm.value);
  //   }
  // }

  onFileChange(event): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.complntImg = file;
    }
  }

  onCloseCmplntModal(): void {
    this.submitCmplnt = false;
    this.complaintForm.reset();
    $('#technical-support').modal('hide');
  }

  onSubmitComplaint(): void {
    this.submitCmplnt = true;
    if (this.complaintForm.invalid) {
      return;
    }
    this.complaintForm.patchValue({
      plant_name: this.empData.cc_desc,
      logged_by: this.empData.username,
      reqcontact: this.empData.mobile,
      reqemail: this.empData.email,
    });
    const cmpForm = new FormData();
    cmpForm.append('plant_name', this.complaintForm.get('plant_name').value);
    cmpForm.append('logged_by', this.complaintForm.get('logged_by').value);
    cmpForm.append('reqcontact', this.complaintForm.get('reqcontact').value);
    cmpForm.append('reqemail', this.complaintForm.get('reqemail').value);
    cmpForm.append('module', this.complaintForm.get('module').value);
    cmpForm.append('subject', this.complaintForm.get('subject').value);
    cmpForm.append('remark', this.complaintForm.get('remark').value);
    cmpForm.append('ticket_screenshot', this.complntImg);
    this.generalServ.complaintGenerate(cmpForm).subscribe(
      (res) => {
        if (res.ticket_master.status) {
          this.onCloseCmplntModal();
          this.notifyService.showSuccess(res.ticket_master.info, 'Success!');
        } else {
          this.notifyService.showError(res.ticket_master.info, 'Error!');
        }
      },
      (err) => {
        this.notifyService.showError('Internal Server Error', 'Error!');
      }
    );
  }

  iconInit(): void {
    this.hasIcons = false;

    this.sideServ.getQuickLinkAll().subscribe((res) => {
      this.modifyQuickLink = res.all_data;
      this.modifyQuickLinkCopy = JSON.parse(JSON.stringify(res.all_data));
      this.modifyQckKey = res.data_key;
      this.modifyQckKeyName = res.key_name;
      this.viewAllMenu(
        this.modifyQuickLink[this.modifyQckKey[0]],
        this.modifyQckKey[0]
      );
    });

    // this.store.pipe(select(GetQuickLinks)).subscribe((res: any) => {
    //   if (res.length !== 0) {
    //     this.hasIcons = true;
    //   } else {
    //     this.hasIcons = false;
    //   }
    //   this.quickLinksIcons = res;
    //   if (this.quickLinksIcons.length > 0) {
    //     this.createNewArray();
    //   }
    //   this.quickLinksIconsCopy = this.quickLinksIcons;
    // });
  }

  createNewArray() {
    for (var i = 0; i < 12; i++) {
      this.quickLinksTemp[i] = this.quickLinksIcons[i];
    }
    this.isViewMore = true;
  }

  viewAllMenu(quickLink, keyname) {
    console.log(quickLink, keyname);
    if (quickLink.length <= 12) {
      this.modifyQuickLink[keyname] = [...this.modifyQuickLinkCopy[keyname]];
    } else {
      this.modifyQuickLink[keyname] = [];
      for (var i = 0; i < 12; i++) {
        this.modifyQuickLink[keyname][i] = this.modifyQuickLinkCopy[keyname][i];
      }
    }
  }

  searchInput(event): void {
    if (event.target.value.length === 0) {
      this.quickLinksIcons = [];
      this.iconInit();
    } else {
      if (event.target.value && event.target.value.trim() !== '') {
        this.srchText = event.target.value;
        this.quickLinksIcons = this.quickLinksIconsCopy;
        this.quickLinksIcons = this.quickLinksIcons.filter((item) => {
          if (
            item.smnu_desc
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) > -1
          ) {
            return (
              item.smnu_desc
                .toLowerCase()
                .indexOf(event.target.value.toLowerCase()) > -1
            );
          }
        });
      }
    }
  }
  ssoLogin(link): void {
    this.generalServ.ssoLogin({ from: link }).subscribe(
      (res) => {
        this.response = res;
        if (this.response.data.status == 1) {
          window.open(this.response.data.url, '_blank');
        } else {
          this.notifyService.showError(this.response.data.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal Server Error!');
      }
    );
  }

  navigate(data): void {
    if (data.smnu_id == '263') {
      this.ssoLogin('sendsms');
      return;
    }
    if (data.smnu_id == '160') {
      this.employeeIdCard();
      return;
    }
    if (data.smnu_id == '261') {
      this.technicalSupport();
      return;
    }
    if (data.smnu_id == '262') {
      this.sodexoPortalLink();
      return;
    }
    if (data.smnu_id == '383') {
      this.refyneModal();
      return;
    }
    if (data.smnu_id == '359') {
      this.employeeVisitingCard();
      return;
    }

    const links = data.link;
    const ext = links.split('.');
    const imgExt = ['pdf', 'PDF', 'jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG'];
    if (ext.length >= 2) {
      const urlExt = ext[ext.length - 1];
      if (imgExt.includes(urlExt)) {
        window.open(data.link, '_self');
      } else {
        window.open(data.link, '_self');
      }
    } else {
      var url = data.portal_url;
      if (data.op_portal_url != '') {
        url = data.op_portal_url;
      }
      if (url == document.location.origin) {
        this.store.dispatch(isQuickLinks({ status: true }));
        this.router.navigate(['/' + data.link]);
      } else {
        this.authSer.appLogin(data.link).subscribe(
          (res) => {
            // window.open(url + '/#/auth/app-login/' + res.data, '_self');
            let route = environment.routing;
            let ren = environment.routingEnable;
            if (ren) {
              window.open(url + '/#/auth/app-login/' + res.data, '_self');
              console.log(
                'url.portal_url' + url + '/#/auth/app-login/' + res.data
              );
            } else {
              console.log('route' + route + '/#/auth/app-login/' + res.data);
              window.open(route + '/#/auth/app-login/' + res.data, '_self');
            }
          },
          (err) => {
            this.notifyService.showError('Something Went Wrong');
          }
        );
      }
    }
  }

  getApplications(): void {
    this.generalServ.getActiveApplication().subscribe((res) => {
      this.response = res;
      this.activeApps = this.response.data;
    });
  }

  approveRej(data, AR): void {
    console.log(data, AR);
    if (AR === 1) {
      this.leaveServe
        .approveLeave({ leave_id: data.lv_id })
        .subscribe((res) => {
          if (res.status) {
            this.notifyService.showSuccess(res.msg, 'Approved');
            data.trans.forEach((el) => {
              if (el.color === '') {
                el.color = 'primary';
              }
            });
            data.pending = 0;
            data.approved = data.trans.length;
            return false;
          }
          this.notifyService.showError(res.msg, 'Approved');
          return false;
        });
    } else if (AR === 2) {
      this.leaveServe.rejectLeave({ leave_id: data.lv_id }).subscribe((res) => {
        if (res.status) {
          data.trans.forEach((el) => {
            if (el.color === '') {
              el.color = 'warn';
            }
          });
          data.pending = 0;
          data.rejected = data.trans.length;
          this.notifyService.showSuccess(res.msg, 'Rejected');
          return false;
        }
        this.notifyService.showError(res.msg, 'Rejected');
        return false;
      });
    } else if (AR === 3) {
      // approved reject
      this.leaveServe
        .rejectLeave({
          leave_id: data.lv_id,
          both_is_approved: 'both_is_approved',
        })
        .subscribe((res) => {
          if (res.status) {
            data.trans.forEach((el) => {
              if (el.color === '') {
                el.color = 'warn';
              }
            });
            data.pending = 0;
            data.approved = 0;
            data.rejected = data.trans.length;
            this.notifyService.showSuccess(res.msg, 'Rejected');
            return false;
          }
          this.notifyService.showError(res.msg, 'Rejected');
          return false;
        });
    }
    // $(modalID).modal({ backdrop: 'static', keyboard: false });
  }

  createMrfApproveForm(): void {
    this.mrfApproveForm = new FormGroup({
      remark: new FormControl(''),
      rel_id: new FormControl('', Validators.required),
      status: new FormControl('', Validators.required),
      rel_group_id: new FormControl('', Validators.required),
      txn_id: new FormControl('', Validators.required),
    });
  }
  createMrfBulkApproveForm(): void {
    this.mrfBulkApproveForm = new FormGroup({
      remark: new FormControl(''),
      status: new FormControl('', Validators.required),
    });
  }

  approvalMrfModal(relId, statusID, header, rel_groupId, txn_Id): void {
    this.mrfApproveFormHeader = header;
    this.mrfApproveForm.patchValue({
      rel_id: relId,
      status: statusID,
      rel_group_id: rel_groupId,
      txn_id: txn_Id,
    });
    $('#mrf_approval_modal').modal({ backdrop: 'static', keyboard: false });
  }
  submitBulkMrfApprove(statusID): void {
    const mrfList = this.mrfApprovals.filter((el) => {
      if (el.isSelected == true) {
        return el;
      }
    });
    // console.log(mrfList)
    // console.log(statusID)
    const params = {
      mrfs: mrfList,
      status: statusID,
      source: 'web',
      type: 'mrf',
    };
    // console.log(params)

    this.dashboardService.bulkMrfApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.notifyService.showSuccess(this.response.msg);
          this.getMyApprovals();
        } else {
          this.notifyService.showError(this.response.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal server error !');
      }
    );
  }
  submitMrfApprove(relId, statusID, rel_groupId, txn_Id): void {
    const params = {
      rel_id: relId,
      status: statusID,
      rel_group_id: rel_groupId,
      txn_id: txn_Id,
      source: 'web',
      type: 'mrf',
    };

    this.dashboardService.mrfApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.notifyService.showSuccess(this.response.msg, '');
          this.mrfApproveForm.reset();
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        // $('#mrf_approval_modal').modal('hide');
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
    // console.log(this.mrfApproveForm.value);
  }
  getMyApprovals(): void {
    this.dashboardService.getMyApprovals().subscribe(
      (res) => {
        //console.log(res);
        this.approvals = res;
        this.showPopup = this.approvals.show_popUp;
        this.marqueeText = this.approvals.marqueeText;
        this.mrfApprovals = this.approvals.data.mrf_approvals;
        this.mrfApprovalsCount = this.approvals.has_mrf_approvals;
        this.napsMrfApprovals = this.approvals.data.naps_mrf_approvals;
        this.napsMrfApprovalsCount = this.approvals.has_naps_mrf_approvals;
        this.transferApprovals = this.approvals.data.transfer_approvals;
        this.transferApprovalsCount = this.approvals.has_transfer_approvals;
        // this.ftcRenewalApprovals = this.approvals.data.renewal_letter;
        // this.ftcRenewalCount = this.approvals.has_renewal_letter;
        this.exitApprovals = this.approvals.data.exit_approvals;
        this.exitApprovalsCount = this.approvals.has_exit_approvals;
        this.awardApprovals = this.approvals.data.award_approvals;
        this.awardApprovalsCount = this.approvals.has_award_approvals;
        this.idCardApprovalsCount = this.approvals.has_id_card_approvals;
        this.idCardApprovals = this.approvals.data.id_card_approvals;
        this.epaApprovalsCount = this.approvals.has_epa_approvals;
        this.epaApprovals = this.approvals.data.epa_approvals;

        this.expenseApprovals = this.approvals.data.expense_approvals.expenses;
        this.expensesCount = this.approvals.data.expense_approvals.expenseCount;
        this.smarttripApprovals =
          this.approvals.data.expense_approvals.smarttrip;
        this.smarttripCount =
          this.approvals.data.expense_approvals.smarttripCount;

        this.workPlaceApprovals = this.approvals.data.wp_approvals;
        this.workPlaceApprovalsCount = this.approvals.has_wp_approvals;
        this.pettyCashApprovalCount = this.approvals.has_petty_cash_approvals;
        this.pettyCashExpenseApprovalCount =
          this.approvals.has_petty_cash_expense_approvals;
        this.pettyCashApprovals = this.approvals.data.petty_cash_approvals;
        this.pettyCashExpenseApprovals =
          this.approvals.data.petty_cash_expense_approvals;
        this.visitingCardApprovalsCount =
          this.approvals.has_visiting_card_approvals;
        this.visitingCardApprovals =
          this.approvals.data.visiting_card_approvals;
        this.ongcpassCount = this.approvals.has_ongc_pass_approvals;
        this.ongcApprovals = this.approvals.data.ongc_pass_approvals;
        this.leaveApprovalsCount = this.approvals.has_leaves_approvals;
        this.pendingEmpBuddyCount = this.approvals.has_pending_emp_map_buddy;
        this.buddyPendingEmployeeList =
          this.approvals.data.pending_emp_map_buddy;
        console.log('yy ', this.ongcApprovals);

        this.totalApprovals =
          this.mrfApprovalsCount +
          this.visitingCardApprovalsCount +
          this.napsMrfApprovalsCount +
          this.awardApprovalsCount +
          this.idCardApprovalsCount +
          this.epaApprovalsCount +
          this.workPlaceApprovalsCount +
          this.pettyCashApprovalCount +
          this.pettyCashExpenseApprovalCount +
          this.visitingCardApprovalsCount +
          this.transferApprovalsCount +
          this.ongcpassCount +
          this.leaveApprovalsCount +
          this.pendingEmpBuddyCount;
        if (this.totalApprovals > 0) {
          this.toggleMenu();
          this.componentPortal = new ComponentPortal(AllApprovalComponent);
          this.selectedPortal = this.componentPortal;
        }
        this.sideServ.setAprvlCount(this.totalApprovals);
      },
      (err) => {}
    );
  }
  getAttendanceReguarisationRequest(): void {
    this.dashboardService.getAttendanceReguarisationRequest().subscribe(
      (res) => {
        console.log(res);
        this.result = res;
        this.attRegulariseData = this.result.data;
        this.attRegulariseDataCount = this.result.count;
        // console.log(this.awardApprovals);
        //  console.log(this.exitApprovals);
      },
      (err) => {}
    );
  }

  // tslint:disable-next-line: typedef   working of EXIT approval
  get exitApproveFormControls() {
    return this.exitApproveForm.controls;
  }
  exitApproveFormField(): void {
    this.exitApproveForm = new FormGroup({
      remark: new FormControl(''),
      exit_id: new FormControl('', Validators.required),
      status: new FormControl('', Validators.required),
    });
  }
  checkUncheckAllMRf(event): void {
    console.log(event.target.checked);
    const checked = event.target.checked;
    this.mrfApprovals.forEach((item) => (item.isSelected = checked));
  }

  approvalBulkMrfModal(header, action): void {
    this.mrfApproveFormHeader = header;
    this.mrfBulkApproveForm.patchValue({
      status: action,
      // remark: ''
    });
    $('#mrf_bulk_approval_modal').modal({
      backdrop: 'static',
      keyboard: false,
    });
  }
  exitApprovalModal(id, header, exitId, statusID): void {
    this.exitHeader = header;
    this.exitApproveForm.patchValue({
      exit_id: exitId,
      status: statusID,
    });
    $(id).modal({ backdrop: 'static', keyboard: false });
  }
  submitExitApprove(
    relID,
    exitId,
    statusID,
    id,
    empId,
    crtrId,
    relLvl,
    reporties_count,
    rpls_rm_id,
    emp_name
  ): void {
    if (reporties_count > 0 && rpls_rm_id == 0 && statusID == 1) {
      this.notifyService.showError(
        'Please update new reporting manager for ' + emp_name + ' reporties',
        ''
      );
      return;
    }
    console.log('rel level', relLvl);
    let params;
    if (id == 0) {
      this.exitRejectForm.patchValue({
        exit_id: exitId,
        status: statusID,
        rel_id: relID,
        emp_user_id: empId,
      });
      $('#exit_reject_remark').modal({ backdrop: 'static', keyboard: false });
      return;
    } else {
      params = {
        exit_id: exitId,
        status: statusID,
        rel_id: relID,
        approver_remark: '',
        emp_user_id: empId,
        creator_user_id: crtrId,
      };
      if (relLvl == 1) {
        Swal.fire({
          title:
            'Do you want to raise replacement MRF for this exiting Employee ?',
          text: '',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.value) {
            this.dashboardService.exitApprovalAction(params).subscribe(
              (res) => {
                this.response = res;
                if (this.response.status == true) {
                  $('#employee_approver_modal').modal('hide');
                  this.closeExitReson();
                  this.notifyService.showSuccess(this.response.msg, '');
                  if (statusID == 1) {
                    this.createExitEmployeeMrf(params);
                  }
                } else {
                  this.notifyService.showError(this.response.msg, '');
                }
                this.exitApproveForm.reset();
                this.getMyApprovals();
              },
              (err) => {
                this.notifyService.showError('Internal server error', '');
              }
            );
          } else {
            this.exitApprovalRequest(params);
          }
        });
      } else {
        this.exitApprovalRequest(params);
      }
    }
  }

  exitApprovalRequest(params): void {
    console.log(params);
    this.dashboardService.exitApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.closeExitReson();
          this.notifyService.showSuccess(this.response.msg, '');
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.exitApproveForm.reset();
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }

  createExitEmployeeMrf(mrfParams): void {
    console.log(mrfParams);
    this.talentService.createExitEmployeeMrf(mrfParams).subscribe(
      (res) => {
        this.result = res;
        if (this.result.status) {
          this.encMrfId = this.result.mrf_enc_id;
          this.router.navigate(['/talent/mrf/' + this.encMrfId]);
        } else {
          this.notifyService.showError(this.result.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal Server Error');
      }
    );
  }

  // used for emp id card
  employeeIdCard(): void {
    $('#employee_idcard').modal({ backdrop: 'static', keyboard: false });
  }

  technicalSupport(): void {
    this.getApplications();
    $('#technical-support').modal({ backdrop: 'static', keyboard: false });
  }

  sodexoPortalLink(): void {
    $('#sodexo-portal-link').modal({ backdrop: 'static', keyboard: false });
  }
  refyneModal(): void {
    $('#refyn_modal').modal({ backdrop: 'static', keyboard: false });
  }

  // -------------- leave rest code ----------
  openHoliday(): void {
    window.open('assets/holiday.pdf', '_blank');
  }
  approvalModal(mrfId): void {
    $('#approval_modal').modal({ backdrop: 'static', keyboard: false });
  }
  rejectModal(ID): void {
    $('#reject_modal').modal({ backdrop: 'static', keyboard: false });
  }

  employeeVisitingCard(): void {
    $('#employee_visiting_card').modal({ backdrop: 'static', keyboard: false });
  }

  sodexoportalMenu() {
    $('#sideMenuBar').css({ left: '4%', 'transition-duration': '300ms' });
    $('#dashboardMenu').hide();
  }
  closePortalMenu() {
    $('#sideMenuBar').css({ left: '-110%', 'transition-duration': '300ms' });
  }

  checkUncheckAllEXIT(event): void {
    console.log(event.target.checked);
    const checked = event.target.checked;
    this.exitApprovals.forEach((item) => (item.isSelected = checked));
  }
  createExitBulkApproveForm(): void {
    this.exitBulkApproveForm = new FormGroup({
      remark: new FormControl(''),
      status: new FormControl('', Validators.required),
    });
  }
  bulkExitApprove(header, action): void {
    this.exitBulkHeader = header;
    this.exitBulkApproveForm.patchValue({
      status: action,
      remark: '',
    });
    $('#exit_bulk_approval_modal').modal({
      backdrop: 'static',
      keyboard: false,
    });
  }
  submitBulkExitApprove(statusID): void {
    const exitList = this.exitApprovals.filter((el) => {
      if (el.isSelected == true) {
        return el;
      }
    });
    if (statusID == 1) {
      for (let index = 0; index < exitList.length; index++) {
        const el = exitList[index];
        if (el.reporties_count > 0 && el.rpls_rm_id == 0) {
          this.notifyService.showError(
            'Please update new reporting manager for ' +
              el.emp_name +
              ' reporties',
            ''
          );
          return;
        }
      }
    }
    // console.log('end');
    // return;
    const params = {
      exit_data: exitList,
      status: statusID,
      remark: '',
    };
    // console.log(params);
    this.dashboardService.bulkExitApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.notifyService.showSuccess(this.response.msg);
          this.getMyApprovals();
          // $('#exit_bulk_approval_modal').modal('hide');
        } else {
          this.notifyService.showError(this.response.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal Server Error !');
      }
    );
  }

  // logged in employee

  getLoggedInEmpDetails(isShow): void {
    this.dashboardService.getLoggedInEmpDetails().subscribe((res) => {
      this.response = res;
      if (this.response.status) {
        this.result = res;
        this.empData = this.result.data;
        const showPopup = localStorage.getItem('showBallon');
        const evntDate = localStorage.getItem('eventDate');
        if (isShow && this.showPopup) {
          if (showPopup == 'true' && evntDate == this.todayDate) {
            this.soNewsModal();
          } else {
            this.greetingModal();
          }
        } else {
          this.soNewsModal();
        }
      } else {
      }
      this.getGeneralNews(this.newsLimit);
    });
  }

  // award Approval

  takeAction(event): void {
    if (event.value == 1) {
      this.btnName = 'Approve';
    } else if (event.value == 0) {
      this.btnName = 'Reject';
    }
  }

  resolveFormFields(): void {
    this.resolveForm = this.formBuilder.group({
      is_approved: ['', Validators.required],
      remark: ['', Validators.required],
    });
  }

  resolveFormFieldsIDCard(): void {
    this.resolveFormIDCard = this.formBuilder.group({
      is_approved: ['', Validators.required],
      remark: ['', Validators.required],
    });
  }
  regulariseFormFields(): void {
    this.regulariseFrom = this.formBuilder.group({
      status: ['', Validators.required],
      remark: ['', Validators.required],
      txn_id: ['', Validators.required],
    });
  }

  resolveFormFieldExpense(): void {
    this.resolveFormExpense = this.formBuilder.group({
      is_approved: ['', Validators.required],
      remark: ['', Validators.required],
    });
  }

  resolveIDCard(data, id): void {
    this.idCardData = data;
    $(id).modal({ backdrop: 'static', keyboard: false });
  }
  onCloseResolveIDCard(): void {
    this.resolveFormIDCard.reset();
    this.submit = false;
    this.loading = false;
    this.btnName = 'Approve';
  }

  onCloseResolveExpense(): void {
    this.resolveFormExpense.reset();
    this.submit = false;
    this.loading = false;
    this.btnName = 'Approve';
  }

  onCloseResolve(): void {
    this.resolveForm.reset();
    this.resolveFormIDCard.reset();
    this.submit = false;
    this.loading = false;
    this.btnName = 'Approve';
  }

  resolveAward(data, id): void {
    this.awardTxn = data;
    $(id).modal({ backdrop: 'static', keyboard: false });
    this.resolveForm.patchValue({
      is_approved: 1,
    });
  }

  onSubmitResolveIDCard(): void {
    this.submit = true;
    if (this.resolveFormIDCard.invalid) {
      return;
    } else {
      const resolveForm = new FormData();
      resolveForm.append(
        'is_approved',
        this.resolveFormIDCard.get('is_approved').value
      );
      resolveForm.append('remark', this.resolveFormIDCard.get('remark').value);
      resolveForm.append('rel_id', this.idCardData.rel_id);
      // tslint:disable-next-line: deprecation
      this.dashboardService
        .idCardApproveAction(resolveForm)
        .subscribe((res) => {
          this.result = res;
          if (this.result.status) {
            $('#take_action_id_card').modal('hide');
            this.onCloseResolveIDCard();
            this.notifyService.showSuccess(this.result.msg);
          } else {
            this.notifyService.showInfo(this.result.msg);
          }
          this.getMyApprovals();
        });
    }
  }
  resolveExpense(data, id): void {
    this.expenseData = data;
    console.log(this.expenseData);
    $(id).modal({ backdrop: 'static', keyboard: false });
    this.resolveFormExpense.patchValue({
      is_approved: 1,
    });
  }

  onSubmitResolveExpense(): void {
    this.submitExp = true;
    if (this.resolveFormExpense.invalid) {
      return;
    } else {
      const resolveForm1 = new FormData();
      resolveForm1.append(
        'status',
        this.resolveFormExpense.get('is_approved').value
      );
      resolveForm1.append(
        'remark',
        this.resolveFormExpense.get('remark').value
      );
      resolveForm1.append('rel_id', this.expenseData.id);
      resolveForm1.append('expns_id', this.expenseData.expns_id);
      resolveForm1.append('upload_source', 'web');
      const chkvalue = this.resolveFormExpense.get('is_approved').value;
      const remarkchk = this.resolveFormExpense.get('remark').value;
      // console.log(chkvalue);
      // console.log(remarkchk);
      if (chkvalue == 0 && (remarkchk == '' || remarkchk == null)) {
        Swal.fire('Please Enter Rejection Remark!', '', 'error');
        return;
      }
      console.log(resolveForm1);
      // tslint:disable-next-line: deprecation
      // return;
      // if (chkvalue == 1 && (this.expenseData.expns_amt > this.expenseData.elgblty_amount)) {
      if (
        chkvalue == 1 &&
        this.expenseData.attachment1 == '' &&
        this.expenseData.attachment2 == ''
      ) {
        Swal.fire({
          title: 'No Bill Found',
          text: 'Do you want to approve it',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes!',
          cancelButtonText: 'No, ',
        }).then((result) => {
          if (result.value) {
            this.submitApiFunction(resolveForm1);
          } else {
            $('#take_action_expense').modal('hide');
            return;
          }
        });
      } else {
        this.submitApiFunction(resolveForm1);
      }
    }
  }
  submitApiFunction(resolveForm1): void {
    this.dashboardService.expenseApprove(resolveForm1).subscribe((res) => {
      this.result = res;
      this.submitExp = false;
      if (this.result.status) {
        $('#take_action_expense').modal('hide');
        this.onCloseResolveExpense();
        this.notifyService.showSuccess(this.result.msg);
      } else {
        this.notifyService.showInfo(this.result.msg);
      }
      this.getMyApprovals();
    });
  }

  onSubmitResolve(): void {
    this.submit = true;
    if (this.resolveForm.invalid) {
      return;
    } else {
      const resolveForm = new FormData();
      resolveForm.append(
        'is_approved',
        this.resolveForm.get('is_approved').value
      );
      resolveForm.append('remark', this.resolveForm.get('remark').value);
      resolveForm.append('rel_id', this.awardTxn.rel_id);
      // tslint:disable-next-line: deprecation
      this.dashboardService.awardApproveAction(resolveForm).subscribe((res) => {
        this.result = res;
        if (this.result.status) {
          $('#take_action').modal('hide');
          this.onCloseResolve();
          this.notifyService.showSuccess(this.result.msg);
        } else {
          this.notifyService.showInfo(this.result.msg);
        }
        this.getMyApprovals();
      });
    }
  }

  // b'day

  getBdays(): void {
    // tslint:disable-next-line: deprecation
    this.dashboardService.getEmpBday().subscribe((res) => {
      this.result = res;
      this.bDayData = this.result.data;
      this.bDayCount = this.result.count;
    });
  }

  getWrkAnnvrsry(): void {
    // tslint:disable-next-line: deprecation
    this.dashboardService.getEmpWrkAnnivrsry().subscribe((res) => {
      this.result = res;
      this.annivrsryData = this.result.data;
      this.annvrsryCount = this.result.count;
    });
  }
  download() {
    console.log('test');
    // window.open('http://localhost/accesshr/public/hello_world.xlsx', "_blank");
  }

  assignQueryMaster(): void {
    this.queryServ.getAssignQueryMaster({ is_excel: 0 }).subscribe((data) => {
      console.log(data);
      if (data.status == true) {
        this.assignQueryData = data.data.data;
        this.assignQueryLength = this.assignQueryData.length;
      } else {
        this.assignQueryData = [];
      }
    });
  }

  editQuery(data, type): void {
    this.queryServ.setTabs(type);
    this.router.navigate(['/queries/master/' + data.qry_id]);
  }

  checkUncheckAllIDCard(event): void {
    console.log(event.target.checked);
    const checked = event.target.checked;
    this.idCardApprovals.forEach((item) => (item.isSelected = checked));
  }
  submitIDCardApprove(relID, reqID, statusID): void {
    // alert(relID);
    // return;
    const params = {
      req_id: reqID,
      status: statusID,
      rel_id: relID,
    };
    console.log(params);
    this.dashboardService.idCardApproveAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.notifyService.showSuccess(this.response.msg, '');
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }
  submitBulkIDCardApprove(statusID): void {
    const idCardList = this.idCardApprovals.filter((el) => {
      if (el.isSelected == true) {
        return el;
      }
    });
    if (idCardList.length == 0) {
      Swal.fire('Please select atleast one id card to approve', '', 'error');
      return;
    }
    // console.log(mrfList)
    // console.log(statusID)
    const params = {
      id_card_lists: idCardList,
      status: statusID,
      source: 'web',
    };
    // console.log(params)

    this.dashboardService.bulkIDCardApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.notifyService.showSuccess(this.response.msg);
          this.getMyApprovals();
        } else {
          this.notifyService.showError(this.response.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal server error !');
      }
    );
  }

  // EPA Approval

  checkUncheckAllEpa(event): void {
    const checked = event.target.checked;
    this.epaApprovals.forEach((element) => {
      element.isSelected = checked;
    });
  }

  submitEpaApproval(relID, statusID): void {
    const params = {
      status: statusID,
      rel_id: relID,
    };
    this.dashboardService.epaApproveAction(params).subscribe((res) => {
      this.response = res;
      if (this.response.status) {
        this.notifyService.showSuccess(this.response.msg);
        this.getMyApprovals();
      } else {
        this.notifyService.showError(this.response.msg);
      }
    });
  }

  submitEpaBulkApproval(statusID): void {
    let msg = 'Approve';
    if (statusID == '0') {
      msg = 'Reject';
    } else {
      msg = 'Approve';
    }
    const epas = this.epaApprovals.filter((element) => {
      if (element.isSelected) {
        return element;
      }
    });
    if (epas.length == 0) {
      Swal.fire(`Please select atleast one EPA to ${msg}`, '', 'error');
      return;
    }
    const params = {
      epa_lists: epas,
      status: statusID,
      source: 'web',
    };

    this.dashboardService.epaBulkApproveAction(params).subscribe((res) => {
      this.response = res;
      if (this.response.status) {
        this.notifyService.showSuccess(this.response.msg);
        this.getMyApprovals();
      } else {
        this.notifyService.showError(this.response.msg);
      }
    });
  }
  // expesne
  checkUncheckAllExpense(event): void {
    console.log(event.target.checked);
    const checked = event.target.checked;
    this.expenseApprovals.forEach((item) => (item.isSelected = checked));
  }
  submitBulkExpenseApprove(statusID): void {
    let msg = 'Approve';
    if (statusID == '0') {
      msg = 'Reject';
    } else {
      msg = 'Approve';
    }
    const expnsList = this.expenseApprovals.filter((el) => {
      if (el.isSelected == true) {
        return el;
      }
    });
    if (expnsList.length == 0) {
      Swal.fire(`Please select atleast one Expense to ${msg}`, '', 'error');
      return;
    }
    const params = {
      expense_data: expnsList,
      status: statusID,
      upload_source: 'web',
    };
    console.log(params);
    this.dashboardService.expenseBulkApprove(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.notifyService.showSuccess(this.response.msg);
          this.getMyApprovals();
        } else {
          this.notifyService.showError(this.response.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal Server Error !');
      }
    );
  }
  submitExpenseApprove(relID, expnsId, statusID): void {
    const params = {
      rel_id: relID,
      expns_id: expnsId,
      status: statusID,
      upload_source: 'web',
    };
    console.log(params);
    // return;
    this.dashboardService.expenseApprove(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.notifyService.showSuccess(this.response.msg, 'Success');
          this.exitApproveForm.reset();
          this.getMyApprovals();
        } else {
          this.notifyService.showError(this.response.msg, 'Error');
        }
      },
      (err) => {
        this.notifyService.showError('Internal Server Error !', '');
      }
    );
  }
  approveRejRegularise(data, statusReq): void {
    if (statusReq == 1) {
      Swal.fire({
        title: 'Are you sure to approve this request ?',
        text: '',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Approve',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          this.regulariseFrom.patchValue({
            txn_id: data.txn_id,
            status: statusReq,
            remark: 'Approved',
          });
          this.onSubmitRegulariseFrom();
        }
      });
    } else {
      console.log(data);
      this.regulariseFrom.patchValue({
        txn_id: data.txn_id,
        status: statusReq,
        remark: '',
      });
      this.submit = false;
      $('#regularise_modal').modal({ backdrop: 'static', keyboard: false });
    }
  }
  onSubmitRegulariseFrom(): void {
    this.submit = true;
    console.log(this.regulariseFrom.value);
    if (this.regulariseFrom.invalid == true) {
      return;
    }

    this.dashboardService
      .regulariseApprove(this.regulariseFrom.value)
      .subscribe(
        (res) => {
          this.response = res;
          if (this.response.status) {
            this.notifyService.showSuccess(this.response.msg, 'Success');
            this.regulariseFrom.reset();
            this.getAttendanceReguarisationRequest();
            $('#regularise_modal').modal('hide');
          } else {
            this.notifyService.showError(this.response.msg, 'Error');
          }
          this.submit = false;
        },
        (err) => {
          this.notifyService.showError('Internal Server Error !', '');
          this.submit = false;
        }
      );
  }

  // workplace permission approval

  submitWrkplaceApproval(data, statusID): void {
    const params = {
      status: statusID,
      rel_id: data.rel_id,
      prmsn_id: data.txn_id,
      client_url: environment.app_url,
      user_id: data.user_id,
    };
    this.dashboardService.workplaceApproveAction(params).subscribe((res) => {
      if (res.status) {
        this.notifyService.showSuccess(res.msg);
        this.getMyApprovals();
      } else {
        this.notifyService.showError(res.msg);
      }
    });
  }

  // bday wish

  // sendWish(data): void {
  //   console.log(data);
  //   this.dashboardService
  //     .sendBdayWish({ user_id: data.user_id })
  //     .subscribe((res) => {
  //       if (res.status) {
  //         this.notifyService.showSuccess(res.msg);
  //       } else {
  //         this.notifyService.showError(res.msg);
  //       }
  //     });
  // }

  checkUncheckAllTransfer(event): void {
    console.log(event.target.checked);
    const checked = event.target.checked;
    this.transferApprovals.forEach((item) => (item.isSelected = checked));
  }

  submitBulkTransferApprove(statusID): void {
    const mrfList = this.transferApprovals.filter((el) => {
      if (el.isSelected == true) {
        return el;
      }
    });
    const params = {
      mrfs: mrfList,
      status: statusID,
      source: 'web',
      type: 'transfer',
    };
    // console.log(params);
    // return;
    this.dashboardService.bulkMrfApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.notifyService.showSuccess(this.response.msg);
          this.getMyApprovals();
        } else {
          this.notifyService.showError(this.response.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal server error !');
      }
    );
  }

  submitTransferApprove(relId, statusID, rel_groupId, txn_Id): void {
    const params = {
      rel_id: relId,
      status: statusID,
      rel_group_id: rel_groupId,
      txn_id: txn_Id,
      source: 'web',
      type: 'transfer',
    };
    // console.log(params);
    // return;
    this.dashboardService.mrfApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.notifyService.showSuccess(this.response.msg, '');
          this.mrfApproveForm.reset();
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }

  tabRight(): void {
    $('#tab_scroll').css({ marginLeft: '-982px', transitionDuration: '0.2s' });
  }
  tabLeft(): void {
    $('#tab_scroll').css({ marginLeft: '8px' });
  }

  getEmpCostCenters(): void {
    this.generalServ.getEmpCostCenters().subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.costCenters = this.response.data;
        } else {
          this.costCenters = [
            { label: 'No data found', value: '', disabled: true },
          ];
        }
      },
      (err) => {
        this.costCenters = [
          { label: 'No data found', value: '', disabled: true },
        ];
      }
    );
  }

  // onSubmitRenewal(Type): void {
  //   console.log(this.renewalForm.get('cc_id').value);
  //   if (this.renewalForm.get('cc_id').value) {
  //     this.showBulkApproval = true;
  //   }
  //   this.renewalForm.patchValue({
  //     type: Type,
  //   });
  //   this.empService
  //     .getRenewEmployeeData(this.renewalForm.value)
  //     .subscribe((res) => {
  //       this.result = res;
  //       if (Type == 0) {
  //         if (this.result.status) {
  //           this.ftcRenewalApprovals = this.result.data;
  //           this.renewalDataCount = this.result.count;
  //           // this.renewalForm.reset();
  //         } else {
  //           this.ftcRenewalApprovals = [];
  //           this.renewalDataCount = 0;
  //         }
  //       }
  //     });
  // }

  // refreshRenewal(): void {
  //   this.renewalForm.reset();
  //   this.showBulkApproval = false;
  //   this.onSubmitRenewal('0');
  // }

  // changeCostCenterID(event): void {
  //   console.log(event.value)
  //   if(event.value){
  //     this.showBulkApproval = true;
  //   }

  // }

  checkUncheckFTCLetter(event): void {
    const checked = event.target.value;
    this.ftcRenewalApprovals.forEach(
      (item) => (item.isSelected = !item.isSelected)
    );
  }

  // generateBulkRenewal(blk, userID, renewID, index): void {
  //   const renewalList = this.ftcRenewalApprovals.filter((el) => {
  //     if (el.isSelected == true) {
  //       return el;
  //     }
  //   });
  //   const params = {
  //     renewalList: renewalList,
  //     type: blk,
  //     user_id: userID,
  //     renew_id: renewID,
  //   };
  //   this.empService.generateRenewalLetter(params).subscribe((res) => {
  //     this.result = res;
  //     this.renewalForm.reset();
  //     if (this.result.status) {
  //       this.showBulkApproval = false;
  //       this.renewLetter = this.result.url;
  //       window.open(this.renewLetter, '_blank');
  //       // this.onSubmitRenewal('0');
  //     } else {
  //       this.notifyService.showError(this.result.msg);
  //     }
  //   });
  // }

  // generateSingleRenewalLetter(data): void {
  //   this.empService.generateSingleRenewalLetter(data).subscribe((res) => {
  //     this.result = res;
  //     this.renewalForm.reset();
  //     if (this.result.status) {
  //       this.showBulkApproval = false;
  //       this.renewLetter = this.result.url;
  //       window.open(this.renewLetter, '_blank');
  //       // this.onSubmitRenewal('0');
  //     } else {
  //       this.notifyService.showError(this.result.msg);
  //     }
  //   });
  // }

  get remarkErrorMsg() {
    return this.rejectForm.controls;
  }

  rejectRenewalletter(usrId, rId, id): void {
    this.rejectForm.patchValue({
      user_id: usrId,
      renew_id: rId,
    });
    $(id).modal('show');
  }

  onSubmitRejection(): void {
    this.remSubmit = true;
    if (this.rejectForm.invalid) {
      return;
    }
    this.empService
      .rejectRenewalLetter(this.rejectForm.value)
      .subscribe((res) => {
        this.result = res;
        if (this.result.status) {
          this.notifyService.showSuccess(this.result.msg);
          this.rejectForm.reset();
          $('#reject_remark').modal('hide');
          this.getMyApprovals();
        } else {
          this.notifyService.showError(this.result.msg);
        }
      });
  }

  closeModal(): void {
    this.rejectForm.reset();
    $('#reject_remark').modal('hide');
  }

  submitPettyCashBulkApproval(statusID): void {
    let msg = 'Approve';
    if (statusID == '0') {
      msg = 'Reject';
    } else {
      msg = 'Approve';
    }
    const epas = this.pettyCashApprovals.filter((element) => {
      if (element.isSelected) {
        return element;
      }
    });
    if (epas.length == 0) {
      Swal.fire(
        `Please select atleast one Petty Cash Request to ${msg}`,
        '',
        'error'
      );
      return;
    }
    const params = {
      pettyCash_lists: epas,
      status: statusID,
      source: 'web',
    };

    console.log(params);
    this.dashboardService
      .pettyCashBulkApproveAction(params)
      .subscribe((res) => {
        this.response = res;
        if (this.response.status) {
          this.notifyService.showSuccess(this.response.msg);
          this.getMyApprovals();
        } else {
          this.notifyService.showError(this.response.msg);
        }
      });
  }

  checkUncheckAllPettyCash(event): void {
    const checked = event.target.checked;
    this.pettyCashApprovals.forEach((element) => {
      element.isSelected = checked;
    });
  }

  closepettyReqModal(): void {
    $('#petty_cash_appr_modal').modal('hide');
    this.pettyReqRejRemark = '';
  }

  closepettyExpnsModal(): void {
    $('#petty_cash_Expense_appr_modal').modal('hide');
    this.pettyExpnsRejRemark = '';
  }

  submitPettyCashApproval(data, statusID): void {
    console.log(data);
    console.log('test1--------');
    this.pettyApprObj = {
      rel_id: data.rel_id,
      lvl: data.rel_level,
      status: statusID,
    };
    console.log('test2-----');
    $('#petty_cash_appr_modal').modal({ backdrop: 'static', keyboard: false });
    console.log('test3-----');
  }

  approveRejPettyRequest(): void {
    if (!this.pettyReqRejRemark && this.pettyApprObj.status == 0) {
      this.notifyService.showError('Please Enter Remark', 'Info!');
      return;
    }
    this.pettyApprObj.approver_remark = this.pettyReqRejRemark;
    this.dashboardService
      .pettyCashApproveAction(this.pettyApprObj)
      .subscribe((res) => {
        if (res.status) {
          this.notifyService.showSuccess(res.msg);
          this.getMyApprovals();
          this.closepettyReqModal();
        } else {
          this.notifyService.showError(res.msg);
        }
      });
  }

  submitPettyCashExpenseApproval(relID, statusID): void {
    console.log(relID);
    this.pettyExpnsApprObj = {
      rel_id: relID,
      status: statusID,
    };
    $('#petty_cash_Expense_appr_modal').modal({
      backdrop: 'static',
      keyboard: false,
    });
    // if (statusID == 0) {
    //   return;
    // }
    // this.dashboardService
    //   .pettyCashExpenseApproveAction(this.pettyExpnsApprObj)
    //   .subscribe((res) => {
    //     if (res.status) {
    //       this.notifyService.showSuccess(res.msg);
    //       this.getMyApprovals();
    //     } else {
    //       this.notifyService.showError(res.msg);
    //     }
    //   });
  }

  rejectPettyExpense(): void {
    if (!this.pettyExpnsRejRemark && this.pettyExpnsApprObj.status == 0) {
      this.notifyService.showError('Please Enter Remark', 'Info!');
      return;
    }
    this.pettyExpnsApprObj.approver_remark = this.pettyExpnsRejRemark;
    this.dashboardService
      .pettyCashExpenseApproveAction(this.pettyExpnsApprObj)
      .subscribe((res) => {
        if (res.status) {
          this.notifyService.showSuccess(res.msg);
          this.getMyApprovals();
          this.closepettyExpnsModal();
        } else {
          this.notifyService.showError(res.msg);
        }
      });
  }

  // map image

  initMap() {
    const directionsService = new google.maps.DirectionsService();
    const directionsRenderer = new google.maps.DirectionsRenderer();
    const map = new google.maps.Map(document.getElementById('map'), {
      zoom: 10,

      center: { lat: 28.387718654034376, lng: 77.31340717021587 },
      gestureHandling: 'none',
      zoomControl: false,
    });

    directionsRenderer.setMap(map);
    this.calculateAndDisplayRoute(directionsService, directionsRenderer);
    // this.cauculateDistance();
    // setTimeout(() => {
    //   this.content.scrollToBottom(200);
    // }, 1000)
  }

  calculateAndDisplayRoute(directionsService, directionsRenderer) {
    directionsService
      .route({
        origin: { lat: 28.387718654034376, lng: 77.31340717021587 },
        destination: { lat: 28.585670394349197, lng: 77.31203387924315 },
        travelMode: google.maps.TravelMode.DRIVING,
      })
      .then(
        (response) => {
          directionsRenderer.setDirections(response);
        },
        (err) => {
          alert(JSON.stringify(err));
        }
      );
  }

  cauculateDistance() {
    const service = new google.maps.DistanceMatrixService();
    const origin1 = { lat: 28.387718654034376, lng: 77.31340717021587 };
    const origin2 = { lat: 28.585670394349197, lng: 77.31203387924315 };
    const request = {
      origins: [origin1],
      destinations: [origin2],
      travelMode: google.maps.TravelMode.DRIVING,
      unitSystem: google.maps.UnitSystem.METRIC,
      avoidHighways: false,
      avoidTolls: false,
    };

    service.getDistanceMatrix(request).then((response) => {
      console.log(response.rows[0].elements[0].distance.text);
      // this.travelDetailsObj.google_km = response.rows[0].elements[0].distance.text;
      console.log(response.rows[0].elements[0].distance.text);
    });
  }

  checkUncheckAllVisitCard(event): void {
    console.log(event.target.checked);
    const checked = event.target.checked;
    this.visitingCardApprovals.forEach((item) => (item.isSelected = checked));
  }

  submitBulkVisitingCardApprove(statusID): void {
    const vstCardList = this.visitingCardApprovals.filter((el) => {
      if (el.isSelected == true) {
        return el;
      }
    });
    if (vstCardList.length == 0) {
      Swal.fire(
        'Please select atleast one Visiting card to approve',
        '',
        'error'
      );
      return;
    }

    const params = {
      vst_card_lists: vstCardList,
      status: statusID,
      source: 'web',
    };

    this.dashboardService.bulkVisitingCardApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.notifyService.showSuccess(this.response.msg);
          this.getMyApprovals();
        } else {
          this.notifyService.showError(this.response.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal server error !');
      }
    );
    // this.dashboardService.bulkIDCardApprovalAction(params).subscribe( res => {
    //     this.response = res;
    //     if (this.response.status){
    //       this.notifyService.showSuccess(this.response.msg);
    //       this.getMyApprovals();
    //     }else{
    //       this.notifyService.showError(this.response.msg);
    //     }
    //   },
    //   err => {
    //       this.notifyService.showError('Internal server error !');
    //   });
  }

  submitVisitingCardApprove(relID, reqID, statusID): void {
    // alert(relID);
    // return;
    const params = {
      req_id: reqID,
      status: statusID,
      rel_id: relID,
    };
    console.log(params);
    this.dashboardService.visitCardApproveAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.notifyService.showSuccess(this.response.msg, '');
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }

  submitOngcPassApprove(reqID, relID, statusID): void {
    const params = {
      req_id: reqID,
      rel_id: relID,
      status: statusID,
    };
    console.log(params);
    this.dashboardService.ongcApproveAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.notifyService.showSuccess(this.response.msg, '');
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }

  submitNapsMrfApprove(relId, statusID, rel_groupId, txn_Id, createdBy): void {
    const params = {
      rel_id: relId,
      status: statusID,
      rel_group_id: rel_groupId,
      txn_id: txn_Id,
      source: 'web',
      creater_id: createdBy,
    };
    this.dashboardService.napsMrfApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.notifyService.showSuccess(this.response.msg, '');
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }

  openRecycleLang(id): void {
    this.refyneList = id;
    console.log('rohit..', this.refyneList);
    $('#lang_modal').modal('show');
    this.getRefineLang(this.refyneList);
  }

  viewReport(): void {
    console.log('>>>Language', this.language);
    if (this.language == undefined || this.language == '') {
      this.notifyService.showError('Please Select language', '');
      return;
    }

    const dataParam = {
      cat_id: this.refyneList,
      language: this.language,
    };

    this.getRefineFiles(dataParam);

    // this.router.navigate(['/quick-links/refyne'],{ queryParams: { lang: this.language,cat_id: this.refyneList }});
    // this.close();
  }

  close(): void {
    this.refyneList = '';
    this.language = '';
    $('#lang_modal').modal('hide');
    $('#refyn_modal').modal('hide');
  }

  getRefineFiles(dataParam): void {
    this.dashboardService.getRefineFiles(dataParam).subscribe((res) => {
      this.hseDocuments = res;
      if (res.status == true) {
        this.close();
        this.docUrl = this.hseDocuments.data.url;
        window.open(this.docUrl, '_blank');
      }
    });
  }

  getRefineLang(refyneList): void {
    console.log(this.refyneList);
    this.dashboardService.getRefineLang(this.refyneList).subscribe((res) => {
      this.refyneLang = res.data;
      console.log('rohit');
      console.log(this.refyneLang);
    });
  }

  openRefyneApp(catID): void {
    this.dashboardService.getRefineLang(catID).subscribe((res) => {
      this.appURL = res.url;
      if (catID == 4) {
        window.open(this.appURL, '_blank');
      }
    });
  }

  refyneAppLabel(): void {
    this.dashboardService.getRefyneAppLabel().subscribe((res) => {
      this.refyneLabel = res.data;
      this.cat_1 = this.refyneLabel.cat_1;
      this.cat_2 = this.refyneLabel.cat_2;
      this.cat_3 = this.refyneLabel.cat_3;
      this.cat_4 = this.refyneLabel.cat_4;
      this.bottomText = this.refyneLabel.botton_text;
      console.log('rohithhhh', this.refyneLabel);
    });
  }

  getNewJoinings() {
    this.dashboardService.getNewJoinings().subscribe((res: any) => {
      if (res.status) {
        this.countNewJoining = res.count;
        this.newJoiningList = res.data;
      }
    });
  }

  getPolicy(): void {
    this.policy.getMostPolicy().subscribe((res) => {
      this.policies = res.data;
    });
    this.getAwards(this.awardLimit);
  }

  getLeaves(id) {
    return this.leaveServe.getLeaves(this.mainLeaves, id);
  }

  addEmployeeLeave(): void {
    console.log('called');
    this.clickEvModal.next('show_modal');
  }
  goToAttendance(): void {
    this.router.navigate(['/leaves']);
  }

  reportiesLeave(): void {
    this.isSelf = false;
    let params = {
      type: 'other',
      emp_id: this.username,
    };

    this.leaveServe.currentLeaveCard(params).subscribe((res) => {
      this.reportiesLeaveMsg = '';
      if (res.status) {
        this.reportLeavesCount = res.data;
      } else {
        this.reportiesLeaveMsg = res.msg;
        this.reportLeavesCount = [];
      }
    });
  }

  leaveCard(): void {
    let params = {
      type: 'self',
    };

    this.leaveServe.currentLeaveCard(params).subscribe((res) => {
      if (res.status) {
        this.mainLeaves = res.data;
        console.log(this.mainLeaves);
      }
    });
  }

  // searchJobsRegular(data): void {
  //   console.log(data);
  //   // return;
  //   this.talentService
  //     .getIjpMrfsRegular({
  //       forms: data,
  //       pageIndex: this.page,
  //       limit: this.pageSize,
  //     })
  //     .subscribe(
  //       (res) => {
  //         this.result = res;
  //         this.ijpListReular = this.result.data2.data;
  //         this.ijpListReularCount = this.result.count;
  //         this.countR = this.result.data2.total;
  //         this.from = this.result.data2.from;
  //         this.to = this.result.data2.to;
  //         // this.cateList = this.ijpList1.emp_cate;
  //         // console.log(this.cateList);
  //       },
  //       (err) => {}
  //     );
  // }

  searchJobsFTC(data): void {
    console.log(data);
    // return;
    this.dashboardService.getHotJobs().subscribe(
      (res) => {
        this.result = res;
        this.ijpListFTC = this.result.dataF;
        this.ijpListReular = this.result.data;
        this.countF = this.result.countF;
        this.countR = this.result.countR;
      },
      (err) => {}
    );
  }

  toggleMenu() {
    // 1-line if statement that toggles the value:
    this.canvasState = this.canvasState === 'out' ? 'in' : 'out';
  }

  sendWish(data, id, type): void {
    $(id).modal('show');
    this.crntBday = data;
    this.wishType = type;
  }

  sendWishWithMsg(): void {
    if (!this.bdayWish) {
      this.notifyService.showError('Please write message', 'Info!');
      return;
    }

    if (this.wishType == 1) {
      this.dashboardService
        .sendBdayWish({ user_id: this.crntBday.user_id, msg: this.bdayWish })
        .subscribe((res) => {
          this.notifyService.showSuccess(res.msg, 'Success!');
          $('#wish_bday').modal('hide');
          this.wishAnimation = true;
          setTimeout(() => {
            this.wishAnimation = false;
          }, 2000);
          this.bdayWish = '';
        });
    }

    if (this.wishType == 2) {
      this.dashboardService
        .sendAnniversaryWish({
          user_id: this.crntBday.user_id,
          msg: this.bdayWish,
        })
        .subscribe((res) => {
          this.notifyService.showSuccess(res.msg, 'Success!');
          $('#wish_bday').modal('hide');
          this.wishAnimation = true;
          setTimeout(() => {
            this.wishAnimation = false;
          }, 2000);
          this.bdayWish = '';
        });
    }
  }

  closeWishModal(): void {
    $('#wish_bday').modal('hide');
    this.bdayWish = '';
  }
  sendOnboardWish(data): void {
    this.dashboardService
      .sendOnboardWish({ user_id: data.user_id })
      .subscribe((res) => {
        this.notifyService.showSuccess(res.msg, 'Success!');
      });
  }

  stpHngr():void {
    this.router.navigate(['/stop-hunger']);
  }
}
